import { UnFollowButton } from "../buttons/FollowUnfollowButtons";
import VerifiedUserIcon from "../UI/VerifiedUserIcon";
import { routes } from "routes";

export const VerifiedButton = () => {
  return (
    <UnFollowButton
      className="verify"
      variant="outlined"
      fullWidth
      sx={{
        display: "flex",
        alignItems: "center",
        "& a": {
          marginTop: "0"
        }
      }}
    >
      <VerifiedUserIcon />
      <a
        href={routes.verify()}
        style={{ marginLeft: "6px", marginTop: "0", color: "white", textDecoration: "none" }}
      >Get Verified</a>
    </UnFollowButton>
  );
};
